import React, { useState } from 'react';
import Pagination from './Pagination';

function ChangeLog({ data }) {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; // Number of rows per page

  // Calculate indices for slicing the data
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentData = data?.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil((data?.length || 0) / itemsPerPage);

  if (!data || data.length === 0) {
    return <div className="text-center">There is no log</div>;
  }

  return (
    <>
      <table className="text-xs w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-200 p-2">
            <th className="border border-gray-300 p-2">Sr. No</th>
            {/* <th className="border border-gray-300 p-2">Key Affected</th> */}
            <th className="border border-gray-300 p-2">Field</th>
            <th className="border border-gray-300 p-2">Old Value</th>
            <th className="border border-gray-300 p-2">New Value</th>
            <th className="border border-gray-300 p-2">Updated By</th>
            <th className="border border-gray-300 p-2">Updated At</th>
          </tr>
        </thead>
        <tbody>
          {currentData.map((item, index) => (
            <React.Fragment key={index}>
              {Object.keys(item.Record || {}).map((key, subIndex) => (
                <tr key={`${index}-${subIndex}`} className="even:bg-gray-50">
                  {subIndex === 0 && (
                    <>
                      <td
                        className="border border-gray-300 text-center p-1"
                        rowSpan={Object.keys(item.Record || {}).length}
                      >
                        {index + 1 + (currentPage - 1) * itemsPerPage}
                      </td>
                      {/* <td
                        className="border border-gray-300 text-center p-1"
                        rowSpan={Object.keys(item.Record || {}).length}
                      >
                        {item.KeyAffected || 'N/A'}
                      </td> */}
                    </>
                  )}
                  <td className="border border-gray-300 text-center p-1">{key}</td>
                  <td className="border border-gray-300 text-center p-1">
                    {item.Record[key]?.old !== undefined
                      ? item.Record[key]?.old.toString()
                      : 'N/A'}
                  </td>
                  <td className="border border-gray-300 text-center p-1">
                    {item.Record[key]?.new !== undefined
                      ? item.Record[key]?.new.toString()
                      : 'N/A'}
                  </td>
                  {subIndex === 0 && (
                    <>
                      <td
                        className="border border-gray-300 text-center p-1"
                        rowSpan={Object.keys(item.Record || {}).length}
                      >
                        {item.UpdatedBy || 'N/A'}
                      </td>
                      <td
                        className="border border-gray-300 text-center p-1"
                        rowSpan={Object.keys(item.Record || {}).length}
                      >
                        {item.Updated_at || 'N/A'}
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>

      {/* Pagination Component */}
      <Pagination
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        totalPages={totalPages}
      />
    </>
  );
}

export default ChangeLog;
